import LoginPage from "@modules/auth/pages/Login";
import SsoAuthentication from "@modules/auth/pages/SsoAuthentication";
import Dashboard from "@modules/dashboard/pages/Dashboard";
import InvoiceParties from "@modules/invoice-parties/pages/InvoiceParties";
import PartnerChannels from "@modules/partner-channel/pages/partnerChannels";
import Partners from "@modules/partners/pages/Partners";
import Publishers from "@modules/publishers/pages/Publishers";
import RoleManagementPage from "@modules/role-management/pages/RoleManagementPage";
import TitleConfiguration from "@modules/title-configuration/pages/TitleConfiguration";
import TriggerPush from "@modules/trigger-push/pages/TriggerPush";
import {
  Dashboard as DashboardIcon,
  Handshake,
  Payment,
  People,
  Publish,
  Security,
  Subtitles,
} from "@mui/icons-material";
import { ReactNode } from "react";

export interface BaseRoute {
  path: string;
  component: React.ComponentType;
  title?: string;
  showInSidebar?: boolean;
  icon?: ReactNode;
  sidebarText?: string;
}

// Public routes (no authentication required)
export const publicRoutes: BaseRoute[] = [
  {
    path: "/login",
    component: LoginPage,
    title: "Login",
  },
  {
    path: "/auth/google/callback",
    component: SsoAuthentication,
    title: "SsoAuthentication",
  },
];

// Protected routes (authentication required)
// Objects which has showInSidebar: true will be shown in sidebar to automate the handling of routes and menu
export const protectedRoutes: BaseRoute[] = [
  {
    path: "/dashboard",
    component: Dashboard,
    title: "Dashboard",
    showInSidebar: true,
    icon: <DashboardIcon />,
    sidebarText: "Dashboard",
  },
  {
    path: "/title-configuration",
    component: TitleConfiguration,
    title: "title-configuration",
    showInSidebar: true,
    icon: <Subtitles />,
    sidebarText: "Title Configuration",
  },
  {
    path: "/invoice-parties",
    component: InvoiceParties,
    title: "invoice-parties",
    showInSidebar: true,
    icon: <Payment />,
    sidebarText: "Invoice Parties",
  },
  {
    path: "/partner-channels",
    component: PartnerChannels,
    title: "partner-channels",
    showInSidebar: true,
    icon: <Handshake />,
    sidebarText: "Partner Channels",
  },
  {
    path: "/publishers",
    component: Publishers,
    title: "publishers",
    showInSidebar: true,
    icon: <Publish />,
    sidebarText: "Publishers",
  },
  {
    path: "/campaigns",
    component: Partners,
    title: "campaigns",
    showInSidebar: true,
    icon: <People />,
    sidebarText: "Campaigns",
  },

  {
    path: "/trigger-push",
    component: TriggerPush,
    title: "trigger-push",
    showInSidebar: false,
    sidebarText: "Trigger Push",
  },
  // {
  //   path: "/push-logs",
  //   component: PushLogs,
  //   title: "push-logs",
  //   showInSidebar: true,
  //   icon: <Feed />,
  //   sidebarText: "Push Logs",
  // },
  {
    path: "/role-management",
    component: RoleManagementPage,
    title: "role-management",
    showInSidebar: true,
    icon: <Security />,
    sidebarText: "Role Management",
  },
  // this route is to handle all route routes to dashboard
  {
    path: "/",
    component: Dashboard,
    title: "Dashboard",
    showInSidebar: false,
  },
];
